import { insertIf, parseDate } from '@roc/feature-utils';
import { SelectEntityOption } from 'libs/feature-one-tool/src/quote/utils/constants';
import { BorrowerEntityInformationSteps } from './constants';

export const mapEntityResponse = data => {
  return data.map(item => ({
    borrowerEntity: {
      borrowerEntityId: item.borrowerEntityId,
      name: item.company.name,
      type: item.type,
      ein: item.ein,
      operatingAgreementDate: parseDate(item.operatingAgreementDate),
      address: item.company.address,
      latitude: item.company.latitude,
      longitude: item.company.longitude,
      streetNumber: item.company.streetNumber,
      streetName: item.company.streetName,
      city: item.company.address,
      state: item.company.state,
      zipCode: item.company.zipCode,
    },
    borrowers: item.borrowers.map(row => ({
      borrowerId: row.borrower.borrowerId,
      firstName: row.borrower.firstName,
      lastName: row.borrower.lastName,
      emailAddress: row.borrower.emailAddress,
      confirmEmailAddress: row.borrower.emailAddress,
      cellPhone: (row.borrower.cellPhone ?? '')
        .replace(/[^\d]/g, '')
        .replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3'),
      pctOwnership: row.pctOwnership,
      experienceProvidedAtOrigination: row.borrower.experience,
      ficoProvidedAtOrigination: row.borrower.ficoProvidedAtOrigination,
      rentalExperience: row.borrower.experience,
    })),
  }));
};

export const getEntityInformationSteps = ({
  isCitizenshipEmpty,
  isFicoOrExperienceEmpty,
  selectEntityOption,
}) => {
  return [
    ...insertIf(isCitizenshipEmpty, [
      BorrowerEntityInformationSteps.BORROWER_CITIZENSHIP,
    ]),
    ...insertIf(isFicoOrExperienceEmpty, [
      BorrowerEntityInformationSteps.BORROWER_CREDIT,
    ]),
    BorrowerEntityInformationSteps.SELECT_ENTITY_OPTION,
    ...insertIf(selectEntityOption === SelectEntityOption.ADD_ENTITY, [
      BorrowerEntityInformationSteps.ADD_ENTITY,
    ]),
    ...insertIf(selectEntityOption === SelectEntityOption.SEARCH_ENTITY, [
      BorrowerEntityInformationSteps.SEARCH_ENTITY,
    ]),
    ...insertIf(selectEntityOption !== SelectEntityOption.SEARCH_ENTITY, [
      BorrowerEntityInformationSteps.BORROWER_INFORMATION,
    ]),
  ];
};
